export function toNumberPrecision(value: number, fractionNumber: number): string {
  const [int, fraction = ''] = value.toFixed(fractionNumber).split('.');
  const fractionWithoutZeros = fraction.replace(/0+$/, '');

  if (fractionWithoutZeros === '') {
    return int;
  }

  return `${int},${fractionWithoutZeros}`;
}
